<script setup lang="ts">
const props = defineProps<{ upsellingPrice: string }>()

const { t } = useLocale()

const upsellingText = computed(
  () => `${t('productDetail.sizes.upselling')} <b>+${props.upsellingPrice}</b>`
)
</script>

<template>
  <div class="w-fit rounded-xl bg-mcd-tertiaryGreenDisabled px-2 py-1" data-test="upselling-badge">
    <p
      v-dompurify-html="upsellingText"
      class="whitespace-nowrap text-xs leading-4 text-mcd-green"
    />
  </div>
</template>
